<template>
  <BaseSelect
    v-model="modelValue"
    v-bind="$attrs"
    v-on="$listeners"
    :options="ACTIVE_INACTIVE_OPTIONS"
    label="BDX Status"
    size="sm"
  />
</template>

<script>
import { defineComponent, computed } from '@vue/composition-api'

import { ACTIVE_INACTIVE_OPTIONS } from '@constants'

import { BaseSelect } from '@components/base'

export default defineComponent({
  name: 'BDXManagementTableFiltersBDXStatus',
  components: {
    BaseSelect
  },
  props: {
    value: {
      type: String,
      default: 'All'
    }
  },
  emits: ['input'],
  setup(props, { emit }) {
    const modelValue = computed({
      get: () => props.value,
      set: (newValue) => emit('input', newValue)
    })

    return {
      ACTIVE_INACTIVE_OPTIONS,

      modelValue
    }
  }
})
</script>
